import Header from '../Header'
import Footer from '../Footer'
import Head from '../Head'
import * as common from '../../common/commonFunction'
import cookie from '../../common/cookieManager'
import commonSession from "../../common/commonSession"
import { setCookie, getCookie } from 'cookies-next';
import { useSpring, animated } from 'react-spring';
import { useEffect, useState } from 'react';
import { FUNDING_AGREE_TITLE, FUNDING_AGREE_CONTENT } from "../../lib/global_variable"
import $ from 'jquery';
import { loadTossPayments } from '@tosspayments/payment-sdk'
import axios from 'axios'
import { isMobile } from "react-device-detect";
import moment, { now } from 'moment'

const FundingModal = (prop) => {

    var sessionInfo = commonSession.getSession()
    const auth = "Bearer " + sessionInfo.token;

    const [active, setActive] = useState('');
    const ticketAmount = prop.ticketAmount ?? 100000;
    const [nowTicketAmount, setNowTicketAmount] = useState(0);
    const bankName = prop.bankName ?? '00은행';
    const bankAccount = prop.bankAccount ?? '000-0000-00000';
    const remainTicket = prop.remainTicket ?? 0;
    const [ticketCnt, setTicketCnt] = useState(0); // ticketCnt
    const [totalAmount, setTotalAmount] = useState(0);
    const [discountAmount, setDiscountAmount] = useState(0);
    const [payType, setPayType] = useState('manual_transfer');// 결제유형
    const [recommendNickName, setRecommendNickName] = useState(''); //입력값 추천인 닉네임 
    const [referralNickname, setReferralNickname] = useState(''); //추천인 닉네임 

    const [moveToBuy, setMoveToBy] = useState(false); //구매페이지로 넘어가는지 확인한다.


    var nickName = sessionInfo.nickName;
    const clientKey = process.env.NEXT_PUBLIC_TOSS_CLIENT_KEY


    useEffect(() => {
        calcAmount('');
        setReferralNickname('');
        setDiscountAmount(0);
        setRecommendNickName('');
        setNowTicketAmount(ticketAmount);
    }, [])

    useEffect(() => {
        calcAmount('');
    }, [nowTicketAmount, recommendNickName, totalAmount, payType, referralNickname])

    useEffect(() => {
        calcAmount('');
    }, [discountAmount])

    const handleChange = (e) => {
        setRecommendNickName(e.target.value)
    };

    // 티켓 총 금액 계산 처리
    function calcAmount(type) {
        var nowTicketCnt = Number(ticketCnt);

        if (type == 'minus') {
            if (ticketCnt > 0) {
                nowTicketCnt = nowTicketCnt - 1;
            }
        } else if (type == 'plus') {
            nowTicketCnt = nowTicketCnt + 1;
        } else {
            // 직접 값 변경 시, 추가 
            nowTicketCnt = $('#total-cnt').val();
        }

        setNowTicketAmount(ticketAmount - discountAmount);
        setTicketCnt(nowTicketCnt);
        setTotalAmount(((ticketAmount - discountAmount) * nowTicketCnt).toLocaleString())

        // 할인 시 할인금액 보여주기 처리 
        if (discountAmount > 0) {
            $('.rec-box').removeClass('d-none');
            $('.rec-box').addClass('d-flex');
            $('.regular-price').html(((ticketAmount) * nowTicketCnt).toLocaleString());
        } else {
            $('.rec-box').removeClass('d-flex');
            $('.rec-box').addClass('d-none');
        }
    }

    function checkNickname() {
        var nickname = recommendNickName;

        if (nickname == sessionInfo.nickName) {
            alert('자기 자신은 추천할 수 없습니다.');
            $('.noti-success').addClass('d-none');
            $('.regular-price').addClass('d-none');
            $('.noti-error').removeClass('d-none');
            setDiscountAmount(0);
            calcAmount('');
            return false;
        }

        const option = {
            url: "/referral/check",
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                "Authorization": auth
            },
            data: {
                nickname: nickname
            }
        }

        axios(option)
            .then(response => {

                if (response.data.result) {
                    //할인처리 
                    $('.noti-error').addClass('d-none');
                    $('.noti-success').removeClass('d-none');
                    $('.regular-price').removeClass('d-none');
                    setReferralNickname(recommendNickName);
                    setDiscountAmount(3000);
                    calcAmount('');
                    setActive('active');
                    
                } else {
                    $('.noti-success').addClass('d-none');
                    $('.regular-price').addClass('d-none');
                    $('.noti-error').removeClass('d-none');
                    setReferralNickname('');
                    setDiscountAmount(0);
                    setRecommendNickName('');
                    alert('추천인 닉네임이 올바르지 않습니다.');
                    calcAmount('');
                    setActive('');

                    return false;
                }
            });
    }

    function buyTicket() {

        if (!sessionInfo.uid || sessionInfo.uid && sessionInfo.uid == '') {
            alert('로그인 후 이용해 주세요.');
            window.location.href = '/login';
            return false;
        }

        if (Number(ticketCnt) < 1) {
            alert('티켓 갯수를 선택/입력해 주세요.');
            return false;
        }

        if (Number(ticketCnt) > remainTicket) {
            alert('최대 구매 가능 티켓 수는 ' + remainTicket.toLocaleString() + ' 개 입니다. 수량을 재선택 해주세요.');
            return false;
        }

        const option = {
            url: "/pay/",
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                "Authorization": auth
            },
            data: {
                fundingId: prop.fundingId,
                totalAmount: Number(nowTicketAmount) * Number(ticketCnt),
                ticketAmount: nowTicketAmount,
                ticketCount: Number(ticketCnt),
                memberId: sessionInfo.uid,
                ticketId: prop.ticketId,
                payType: payType, // 결제유형 추가 -- 토스 추가되어서 
                orderName: '[MYM-B]콘텐츠 제작 티켓', // 주문상품명 추가 -- 토스 추가되어서 
                status: 'O1',
                referralTo: referralNickname ?? ''
            }
        }

        axios(option)
            .then(response => {
                console.log(referralNickname);
                console.log(response);
                if (response.status == 200) {
                    // 토스 결제 추가 
                    if (payType == 'TOSS') {
                        moveTossPayments(response.data.data.orderId);
                        return false;
                    } else {
                        alert("구매 신청이 완료되었습니다. \n 2 영업 일 이내에 입금 확인 후 구매가 확정 됩니다.");
                        window.location.href = '/mypage/NFT';
                    }
                }
            });
    }

    const setBuyType = (e) => {
        var type = $(e.target).attr('data-type');

        var target = $(e.target)

        if (type == 'TOSS') target = $(e.target).parent('.pay-type-btn')

        if (target.hasClass('active')) {
            target.removeClass('active');
            setPayType('')
        } else {
            $('.pay-type-btn').removeClass('active');
            target.addClass('active');
            setPayType(type)
        }
    }

    // Promise를 사용하는 경우
    const moveTossPayments = (orderId) => {

        console.log(orderId);
        loadTossPayments(clientKey).then(tossPayments => {

            tossPayments.requestPayment('계좌이체', {
                amount: (nowTicketAmount) * ticketCnt,
                orderId: orderId,
                orderName: '[MYM-B]콘텐츠 제작 티켓',
                customerName: nickName,
                successUrl: 'https://adultoon.mym-b.com/orderComplete',
                failUrl: 'https://adultoon.mym-b.com/orderFail',
            })

        })
    }


    function move(number) {
        if (number > 0) {
            console.log(number);
            console.log(moveToBuy);
            if (moveToBuy || number == 2) {

                if(discountAmount > 0){
                    checkNickname();

                    if(active != ''){
                        buyTicket();
                    }
                }else{
                    buyTicket();
                }
            } else {
                if (!$('#agree-btn').is(':checked')) {
                    alert('서비스 이용 약관에 동의해주세요.');
                    return false;
                }else if(!$('#age-btn').is(':checked')) {
                    alert('19세 이상임을 체크해주세요.');
                    return false;
                } else {
                    setMoveToBy(true);
                    $('.funding-popup-1').addClass('d-none');
                    $('.funding-popup-2').removeClass('d-none');
                }
            }
        } else {
            setMoveToBy(false);
            $('.funding-popup-1').removeClass('d-none');
            $('.funding-popup-2').addClass('d-none');
            $('#fundingModalPopup').css('display', 'none');

            setDiscountAmount(0)
            setRecommendNickName('');
        }
    }


    return (
        <>
            {isMobile ? <link rel='stylesheet' href='/css/mobile/funding-modal.min.css' /> : <link rel='stylesheet' href='/css/funding-modal.min.css' />}
            <div className="container w-100 text-center m-0">
                <div className="modal" id="fundingModalPopup">
                    <div className="modal_body w-80 funding-popup-1">
                        <p className="funding-modal-title">저작권 구매</p>
                        <p className="fundinb-sub-title">사용자 이용 약관을 반드시 확인해 주세요.</p>
                        <div className="agree-content">
                            <p className="title">{FUNDING_AGREE_TITLE}</p>
                            <div className="agree-text" dangerouslySetInnerHTML={{ __html: FUNDING_AGREE_CONTENT }}>
                            </div>
                        </div>
                        <div className="agree-box">
                            <div className="agree-text">
                                <input type="checkbox" id="agree-btn" name="agree_service" value="1"></input>
                                <label htmlFor="agree-btn"></label>
                                <span onClick={() => $('#agree-btn').trigger('click')}>서비스 이용 약관에 동의합니다</span>
                            </div>
                        </div>
                        <div className="agree-box">
                            <div className="agree-text">
                                <input type="checkbox" id="age-btn" name="age_service" value="1"></input>
                                <label htmlFor="age-btn"></label>
                                <span onClick={() => $('#age-btn').trigger('click')}>19세 이상입니다.</span>
                            </div>
                        </div>
                        <ul className="notice-box">
                            <li>본 작품이 제작되는 과정에 커뮤니티 일원으로 참여 가능.</li>
                            <li>웹툰이 2차, 3차 저작물로 제작될 때 구매한 참여티켓에 비례하여 저작권 획득 가능.</li>
                        </ul>
                        <div className="btn-box d-flex align-items-center justify-content-between">
                            <div className="btn primary-btn bg-normal w-50" id="canc-btn" onClick={() => move(-1)}>취소</div>
                            <div className="btn primary-btn bg-primary w-50" id="next-btn" onClick={() => move(1)}>다음</div>
                        </div>
                    </div>
                    <div className="modal_body w-80 funding-popup-2 d-none">
                        <p className="funding-modal-title">저작권 구매</p>
                        <p className="fundinb-sub-title">1.본 작품이 제작되는 과정에 커뮤니티 일원으로 참여 가능.</p>
                        <p className="fundinb-sub-title">2.웹툰이 2차, 3차 저작물로 제작될 때,<br />구매한 참여티켓에 비례하여 저작권 획득 가능.</p>
                        <div className="buy-box">
                            <div className="ticket-box d-flex align-items-center justify-content-start">
                                <p className="form-title">티켓가격</p>
                                <p className="form-content"><span className='ticket-amount c-primary'>{nowTicketAmount == ticketAmount ? nowTicketAmount : ticketAmount}</span> ₩/1EA</p>
                            </div>
                            <div className="rec-box d-none align-items-center justify-content-start">
                                <p className="form-title">추천인 할인</p>
                                <p className="form-content"><span className='ticket-amount'>{discountAmount.toLocaleString()}</span> ₩</p>
                            </div>
                            <div className="buy-type d-flex align-items-center justify-content-start">
                                <p className="form-title">결제방식</p>
                                <div className="d-flex align-items-center justify-content-start">
                                    <button type="button" className="pay-type-btn active" data-type="manual_transfer" onClick={setBuyType}>계좌이체</button>
                                    <button type="button" className="pay-type-btn btn-toss" data-type="TOSS" onClick={setBuyType}><img src="/img/toss_logo.png" style={{ height: "40px", padding: "0" }} data-type="TOSS"></img></button>
                                </div>
                            </div>
                            <div className="account-box d-flex align-items-center justify-content-start">
                                <p className="form-title">입금계좌 정보</p>
                                <p>{bankName} {bankAccount}</p>
                            </div>
                            <div className="buy-cnt d-flex align-items-center justify-content-start">
                                <p className="form-title">구매수량</p>
                                <p><input className="buy-cnt form-control box" id="total-cnt" name="total_cnt" value={ticketCnt} onChange={() => calcAmount('')} /><i className="minus-count" onClick={() => calcAmount('minus')}></i><i className="plus-count" onClick={() => calcAmount('plus')}></i></p>
                            </div>
                            <div className="buy-amount d-flex align-items-center justify-content-start">
                                <p className="form-title">총 금액</p>
                                <p><span className="regular-price d-none" id="regular-price"></span><span className="buy-amount c-primary" id="total-amount">{totalAmount ?? 0}</span> ₩</p>
                            </div>
                            <div className="buy-amount d-flex align-items-center justify-content-start">
                                <p className="form-title">추천인 닉네임</p>
                                <p>
                                    <input className="form-control box d-inline-block w-60 text-start" id="recommend-nickname" name="recommend-nickname" value={recommendNickName} onChange={handleChange} />
                                    <button type="button" className="account-btn secured_edit" onClick={checkNickname} style={{ width: "calc(40% - 10px)", marginLeft: "10px;", display: 'inline-block' }}>확인</button>
                                    <p className="d-none noti-error">추천인 닉네임이 올바르지 않습니다.</p>
                                    <p className="d-none noti-success">추천인 닉네임이 확인되었습니다. (3,000원 할인)</p>
                                </p>
                            </div>
                        </div>
                        <div className="btn-box d-flex align-items-center justify-content-between">
                            <div className="btn primary-btn bg-normal w-50" id="canc-btn-2" onClick={() => move(-1)}>취소</div>
                            <div className="btn primary-btn bg-primary w-50" id="next-btn-2" onClick={() => move(2)}>결제</div>
                        </div>
                    </div>
                </div >
            </div >
        </>
    )
}
export default FundingModal;